import React, { useState, useRef, useMemo, useEffect } from 'react';
import LS from '../../styles/layoutStyled';
import CS from '../../styles/componentStyled';
import styled, { css } from 'styled-components';
import InputModal from '../InputModal';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { userIdState } from '../../atom/TokenAtom';
import {
  EntryListsDto,
  EntryListDto,
  PourListSearchDto,
  PourListDto,
  WorkStartCurrentLocationListDto,
  WorkStartCurrentLocationListsDto,
} from '../../model/room.dto';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
  currentLocationStateRecoil,
} from '../../atom/ModalAtom';
import WorkNum from '../../component/WorkNum';
import { socketio } from '../../api/socket.api';
import eventbus from '../../api/eventbus';
import { roomAPI } from '../../api/axiosIndex';
import Input from '../../component/Input';
import Table from '../../component/Table';
import { Icon } from '../../component/Icon';
import { Map, MapMarker, Circle } from 'react-kakao-maps-sdk';
import { useParams } from 'react-router-dom';
// 타설 목록 모달에서 가져와서 사용
import { SearchBtn } from './PourList';
import { CustomOverlayMap } from 'react-kakao-maps-sdk';

const CurrentLocation = () => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const { id } = useParams<{ id: string }>();

  const setModalState = useSetRecoilState(currentLocationStateRecoil);

  const [mapKey, setMapKey] = useState('');
  const [userNumber, setUserNumber] = useState('');

  // 선택된 마커의 userId
  const [selectedMarker, setSelectedMarker] = useState<string>('');
  const [latitude, setLatitude] = useState<number>(0);
  const [longitude, setLongitude] = useState<number>(0);
  const [entranceLatitude, setEntranceLatitude] = useState<number>(0);
  const [entranceLongitude, setEntranceLongitude] = useState<number>(0);
  const [radius, setRadius] = useState<number>(0);
  const [currentLocationList, setCurrentLocationList] = useState<
    WorkStartCurrentLocationListDto[]
  >([]);
  const [searchTrigger, setSearchTrigger] = useState<boolean>(false);

  // 입차지 정보 조회
  const getEntrySite = async () => {
    try {
      const response = await roomAPI.getEntrySite(Number(id));
      if (response) {
        setLatitude(response.data.latitude);
        setLongitude(response.data.longitude);
        setEntranceLatitude(response.data.latitude);
        setEntranceLongitude(response.data.longitude);
        setRadius(response.data.radius);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // 업무 시작한 기사들 현재 위치 정보 조회
  const getCurrentLocation = async () => {
    try {
      const response = await roomAPI.getWorkStartCurrentLocation(
        Number(id),
        userNumber !== '' ? userNumber : '',
      );
      if (response.data) {
        setCurrentLocationList(response.data);

        const highLightUser = response.data.find((item) => item.isHighlight);
        if (highLightUser) {
          setSelectedMarker(String(highLightUser.userId));
          setLatitude(highLightUser.latitude);
          setLongitude(highLightUser.longitude);
        } else {
          setSelectedMarker('');
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  // 검색 버튼 클릭
  const handleSearch = () => {
    getCurrentLocation();
    setMapKey(String(Date.now()));
    setSearchTrigger(!searchTrigger);
  };

  // 입차지 정보 조회 useEffect
  useEffect(() => {
    getEntrySite();
  }, []);

  // 업무 시작한 기사들 현재 위치 정보 조회 useEffect
  useEffect(() => {
    if (radius !== 0) {
      getCurrentLocation();
    }
  }, [mapKey, radius]);

  useEffect(() => {
    const interval = setInterval(() => {
      console.log('interval');
      console.log(radius);
      if (radius !== 0) {
        getCurrentLocation();
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [searchTrigger, radius]);

  return (
    <>
      <InputModal
        title="현위치"
        onCancel={() => setModalState(false)}
        onlyView={true}
        isFullScreen={true}
      >
        <SearchWrap>
          <div className="input-wrap">
            <Input
              placeholder="사번 입력"
              type="text"
              width="100%"
              theme="type2"
              value={userNumber}
              setValue={setUserNumber}
            />
            <SearchBtn onClick={handleSearch}>
              <span className="img-box">
                <Icon name="SearchIcon" size="100%" color="#fff" />
              </span>
            </SearchBtn>
          </div>
        </SearchWrap>
        <MapBox>
          <Map
            key={mapKey}
            center={{ lat: latitude, lng: longitude }}
            style={{ width: '100%', height: '100%' }}
            level={5}
            draggable={true}
            zoomable={true}
          >
            {currentLocationList.map((item) => (
              <CustomOverlayMap
                key={item.userId}
                position={{ lat: item.latitude, lng: item.longitude }}
                zIndex={Number(selectedMarker) === item.userId ? 1 : 0}
              >
                <div
                  className={`marker-box ${
                    Number(selectedMarker) === item.userId ? 'active' : ''
                  }`}
                >
                  <span className="label">{item.userNumber}</span>
                  <span className="img-box">
                    <img src="/icons/ico_truck.svg" alt="" />
                  </span>
                </div>
              </CustomOverlayMap>
            ))}
            {radius && (
              <Circle
                center={{ lat: entranceLatitude, lng: entranceLongitude }}
                radius={radius}
                strokeWeight={1}
                strokeColor="#F0A400"
                strokeOpacity={1}
                strokeStyle="solid"
                fillColor="#F0A400"
                fillOpacity={0.25}
              />
            )}
          </Map>
        </MapBox>
      </InputModal>
    </>
  );
};

export default CurrentLocation;

const SearchWrap = styled.div`
  width: 100%;
  .input-wrap {
    margin-top: 8px;
    display: grid;
    grid-template-columns: 1fr 36px;
    gap: 4px;
  }
`;

export const MapBox = styled.div`
  width: 100%;
  height: calc(100vh - 198px);
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  margin-top: 8px;
  .marker-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    .label {
      background-color: white;
      box-sizing: border-box;
      border: 1px solid #aaa;
      border-radius: 2px;
      padding: 2px 6px;
      font-size: 12px;
      color: #333;
      white-space: nowrap;
    }
    .img-box {
      width: 28px;
    }
  }
  .active {
    .label {
      color: #f0a400;
      font-weight: 700;
    }
  }
`;
